import { ItemFromIntention } from '@interfaces/analysis/orders-intentions-for-approval/item-from-intention';
import { ItemFromOrderAnalytical } from '@interfaces/analysis/orders-intentions-for-approval/item-from-order-analytical';
import { ItemFromOrderSynthetic } from '@interfaces/analysis/orders-intentions-for-approval/item-from-order-synthetic';
import { OrdersIntentionsApprovalType } from '../../../../../@types/enums/orders-intentions-approval-type-enum';
import { Button, Card, Form, Modal, Table } from 'react-bootstrap';
import { useMemo, useState } from 'react';
import { ParseToCurrencyBR } from 'helper/format-currency';
import { TableHeaderStyled } from 'pages/style/table/table-header';
import { useOrderIntentionsLists } from 'data/context/analysis/orders-intetions-lists-context';
import { ModalConfirmAction } from 'components/modal/modal-confirm-action-component';
import { DadosPii } from '@interfaces/analysis/campaign-pii-data';
import { ModalCampaignPiiData } from './modal-campaign-pii-data';

interface PropsModalItemsOrdersIntentions {
  showModalItemsOI: boolean;
  closeModalItemsOI: () => void;
  title: string | undefined;
  type: OrdersIntentionsApprovalType;
  isEdit: boolean;
  campaignFull?: boolean;
}

const toBoolean = (value: any) => value === true || value === 'true' || value === 1 || value === '1';

export const ModalItemsOrdersIntentions: React.FC<PropsModalItemsOrdersIntentions> = ({
  showModalItemsOI,
  closeModalItemsOI,
  title,
  type,
  isEdit,
  campaignFull,
}) => {
  const [precoReposicaoTotal, setPrecoReposicaoTotal] = useState(0);
  const [precoComStDescontoTotal, setPrecoComStDescontoTotal] = useState(0);
  const [precoSemStDescontoTotal, setPrecoSemStDescontoTotal] = useState(0);
  const [showModalConfirmAction, updateShowModalConfirmAction] = useState(false);
  const openModalConfirmAction = () => updateShowModalConfirmAction(true);
  const closeModalConfirmAction = () => {
    updateShowModalConfirmAction(false);
    updateDadosPiiSend(undefined);
  };
  const [showModalPii, updateShowModalPii] = useState(false);
  const [dadosPiiSend, updateDadosPiiSend] = useState<DadosPii | undefined>(undefined);
  const openModalPii = () => updateShowModalPii(true);
  const closeModalPii = () => updateShowModalPii(false);

  const {
    items,
    setItems,
    observacao,
    setObservacao,
    approveAnalitycal,
    approveSynthetic,
    approveIntention,
    rejectAnalitycal,
    rejectSynthetic,
    rejectIntention,
    meliOptions,
  } = useOrderIntentionsLists();

  let isAnalitycal: boolean = type === OrdersIntentionsApprovalType.ANALITICO;
  let isSynthetic: boolean = type === OrdersIntentionsApprovalType.SINTETICO;
  let isCampaign: boolean = type === OrdersIntentionsApprovalType.CAMPANHA;
  let isCampaignFull: boolean = isCampaign && (toBoolean(campaignFull) || items.some((item) => toBoolean(item.campanhaFull)));
  let labelHeader = isCampaign ? 'Inteção' : 'Pedido';
  let labelApproveButton = isCampaign ? 'Enviar para Fábrica' : 'Gerar Pedido';
  let totalValue = isCampaign
    ? `Total com ST: ${ParseToCurrencyBR(precoComStDescontoTotal)} - Total sem ST: ${ParseToCurrencyBR(precoSemStDescontoTotal)}`
    : `Total ${ParseToCurrencyBR(precoReposicaoTotal)}`;

  useMemo(() => {
    let precoReposicaoTotal = 0;
    let precoComStDescontoTotal = 0;
    let precoSemStDescontoTotal = 0;
    if (isCampaign) {
      items.forEach((item) => {
        precoComStDescontoTotal += item.precoComStDesconto * item.quantidadeRealizada;
        precoSemStDescontoTotal += item.precoSemStDesconto * item.quantidadeRealizada;
      });
      setPrecoComStDescontoTotal(precoComStDescontoTotal);
      setPrecoSemStDescontoTotal(precoSemStDescontoTotal);
    } else {
      items.forEach((item) => {
        precoReposicaoTotal += item.precoReposicao * item.quantidadeRealizada;
      });
      setPrecoReposicaoTotal(precoReposicaoTotal);
    }
  }, [items]);

  function handleInputBlurQuantity(value: any, itemChanging: ItemFromOrderAnalytical & ItemFromOrderSynthetic & ItemFromIntention) {
    let newList = items.map((item) => {
      if (((isAnalitycal || isSynthetic) && itemChanging.idPedido === item.idPedido) || (isCampaign && itemChanging.idItem == item.idItem)) {
        item.quantidadeRealizada = value;
      }
      return item;
    });
    setItems(newList);
  }

  function approveAction() {
    if (isAnalitycal) {
      approveAnalitycal(items, observacao);
    }
    if (isSynthetic) {
      approveSynthetic(items, observacao);
    }
    if (isCampaign) {
      if (isCampaignFull) {
        openModalPii();
      } else {
        openModalConfirmAction();
      }
    } else {
      closeModalItemsOI();
    }
  }

  function rejectAction() {
    if (isAnalitycal) {
      rejectAnalitycal(items, observacao);
    }
    if (isSynthetic) {
      rejectSynthetic(items, observacao);
    }
    if (isCampaign) {
      rejectIntention(items[0].idIntencao, observacao);
    }
    closeModalItemsOI();
  }

  async function confirmSendOrder() {
    const dadosPii = dadosPiiSend;
    approveIntention(items, observacao, dadosPii);
    updateShowModalConfirmAction(false);
    updateDadosPiiSend(undefined);
    closeModalItemsOI();
  }

  function confirmPiiData(dadosPii: DadosPii) {
    updateDadosPiiSend(dadosPii);
    closeModalPii();
    openModalConfirmAction();
  }

  return (
    <Modal show={showModalItemsOI} onHide={closeModalItemsOI} size="xl" backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Card className="mt-3" style={{ maxHeight: '60vh' }}>
          <TableHeaderStyled>
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th colSpan={12} className="text-center">
                    Itens {labelHeader}
                  </th>
                </tr>
                <tr>
                  <th colSpan={12} className="text-center">
                    {totalValue}
                  </th>
                </tr>
                <tr>
                  {!isCampaign && <th className="text-center">Filial</th>}
                  <th className="text-center">Sufixo</th>
                  <th className="text-center">Descrição</th>
                  {!isCampaign && <th className="text-center">Preço Reposição</th>}
                  {isAnalitycal && <th className="text-center">Custo Médio</th>}
                  {isCampaign && <th className="text-center">Preco Com ST com Desconto</th>}
                  {isCampaign && <th className="text-center">Preco Sem ST com Desconto</th>}
                  <th className="text-center">QME</th>
                  <th className="text-center">Quantidade Solicitada</th>
                  <th className="text-center">Quantidade Realizada</th>
                </tr>
              </thead>
              <tbody className="text-center">
                {(console.log("items -> ", items), null)}
                {items && items.length > 0 ? (
                  items.map((item) => (
                    <tr key={isCampaign ? item.idIntencao : item.idPedido}>
                      {!isCampaign && <td className="text-center">{item.idFilial}</td>}
                      <td className="text-center">{item.sufixo}</td>
                      <td className="text-center">{item.descricao}</td>
                      {!isCampaign && <td className="text-center">{ParseToCurrencyBR(item.precoReposicao)}</td>}
                      {isAnalitycal && <td className="text-center">{ParseToCurrencyBR(item.custoMedio)}</td>}
                      {isCampaign && <td className="text-center">{ParseToCurrencyBR(item.precoComStDesconto)}</td>}
                      {isCampaign && <td className="text-center">{ParseToCurrencyBR(item.precoSemStDesconto)}</td>}
                      <td className="text-center">{item.qme}</td>
                      <td className="text-center">{item.quantidade}</td>
                      <td className="text-center">
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          <Form.Control
                            disabled={!isEdit}
                            className={`m-0 p-0 mx-2`}
                            type="number"
                            min="0"
                            defaultValue={item.quantidadeRealizada}
                            size="sm"
                            style={{ width: 50 }}
                            onBlur={(e) => handleInputBlurQuantity(parseInt(e.target.value), item)}
                            onKeyDown={(evt) =>
                              (evt.key === 'e' || evt.key === '-' || evt.key === '.' || evt.key === ',' || evt.key === "'") && evt.preventDefault()
                            }
                          />
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <></>
                )}
              </tbody>
            </Table>
          </TableHeaderStyled>
        </Card>

        <Form.Group className="mb-3 mt-2">
          <Form.Label>Observação:</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            maxLength={300}
            defaultValue={observacao}
            onChange={(e) => setObservacao(e.currentTarget.value)}
            disabled={!isEdit}
          />
          {isEdit && <Form.Label style={{ display: 'block', textAlign: 'right' }}>{observacao !== null ? observacao.length : 0}/300</Form.Label>}
        </Form.Group>
      </Modal.Body>
      {isEdit && (
        <Modal.Footer>
          <Button size="sm" variant="success" onClick={approveAction}>
            {labelApproveButton}
          </Button>
          <Button size="sm" variant="danger" onClick={rejectAction}>
            Reprovar
          </Button>
        </Modal.Footer>
      )}
      <ModalConfirmAction
        confirmActionFunction={() => {
          confirmSendOrder();
        }}
        confirmButtonMessage="Enviar"
        closeButtonMessage="Cancelar"
        closeModalConfirmAction={closeModalConfirmAction}
        message="Confirmar o envio do pedido"
        showModalConfirmAction={showModalConfirmAction}
        titleConfirmAction="Enviar Pedido"
      />
      <ModalCampaignPiiData
        showModalPii={showModalPii}
        closeModalPii={closeModalPii}
        meliOptions={meliOptions}
        confirmActionFunction={confirmPiiData}
      />
    </Modal>
  );
};
